import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SponsorCTA() {
  return (
    <section
      data-testid="sponsor-cta"
      className="relative py-20 md:py-32 overflow-hidden bg-[#0A0A0A]"
    >
      {/* halftone accent */}
      <div className="absolute -bottom-12 -left-12 w-80 h-80 halftone opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs tracking-[0.25em] uppercase font-bold mb-3">
            <span className="text-[#E10600]">Brand</span>{" "}
            <span className="text-zinc-500">×</span>{" "}
            <span className="text-[#1E6FE0]">Partnerships</span>
          </p>
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-none">
            Put Your <span className="text-[#E10600]">Brand</span><br />
            In The <span className="text-[#1E6FE0]">Conversation</span>
          </h2>
          <p className="mt-6 text-lg text-zinc-300">
            The relationship & lifestyle audience advertisers can't reach on
            network. Loyal, engaged, and split evenly across men and women — host-read
            integrations from someone the culture actually trusts.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/sponsorship" data-testid="sponsor-cta-explore" className="btn-primary">
              Explore Sponsorship
              <ArrowUpRight className="w-4 h-4" />
            </Link>
            <Link to="/media" data-testid="sponsor-cta-media-kit" className="btn-blue">
              Download Press Kit
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
